import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './RugCardContainer'
import Enhancer from './RugCardEnhancer'

import RugCardContent from 'Components/RugCard/RugCardContent'
import RugCardHeader from 'Components/RugCard/RugCardHeader'
import RugCardPicture from 'Components/RugCard/RugCardPicture'
import RugCardPictureSource from 'Components/RugCard/RugCardPictureSource'
import RugCardReservationsStatus from 'Components/RugCard/RugCardReservationsStatus'
import RugCardStatus from 'Components/RugCard/RugCardStatus'

import * as rugHelpers from 'Global/Helpers/rugHelpers'
import * as styles from './styles'
import { getCurrent, getUpcoming } from 'Global/Helpers/reservationHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCard = props => {
  const { enablePreview, fixedHeight, fromPage, handleTogglePreview, noRibbon, rug, userPermissions } = props

  const currentReservation = getCurrent(rug.reservations)

  const upcomingReservations = getUpcoming(rug.reservations).map(r => {
    return <div key={r.id}>{`${getFormattedDateString(r.dateFrom)} – ${getFormattedDateString(r.dateTo)}`}</div>
  })

  return (
    <Card color={rugHelpers.getStatus(rug).color} style={fixedHeight ? styles.fixedHeight : {}} fluid raised>
      <RugCardPicture
        isMasterpiece={rug.isMasterpiece}
        fromPage={fromPage}
        noRibbon={noRibbon}
        rug={rug}
        userPermissions={userPermissions}
      />

      <RugCardHeader fromPage={fromPage} rug={rug} />

      <RugCardContent rug={rug} />

      <RugCardStatus noRibbon={noRibbon} rug={rug} />

      <RugCardReservationsStatus current={currentReservation} upcoming={upcomingReservations} />

      <RugCardPictureSource enablePreview={enablePreview} rug={rug} togglePreview={handleTogglePreview} />
    </Card>
  )
}

RugCard.propTypes = {
  enablePreview: PropTypes.bool.isRequired,
  fixedHeight: PropTypes.bool.isRequired,
  fromPage: PropTypes.string.isRequired,
  handleTogglePreview: PropTypes.func.isRequired,
  index: PropTypes.number,
  noRibbon: PropTypes.bool.isRequired,
  rug: PropTypes.object.isRequired,
  userPermissions: PropTypes.array.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(RugCard)
